import { P0, S, abs, arc, fillAt, max, sq } from '../../geometry';

export const frog = {
  name: 'Frog',
  colors: ['#2F9E5B', '#161616'],
  draw(m, t) {
    let bL = 0.8 * S(t * 1.5),
      bR = 0.8 * S(t * 1.5 + 1),
      hw = 30,
      hh = 17,
      fly = 0,
      leg = 0,
      pose = P0();
    if (m === 'happy') {
      pose.ty = -6 * abs(S(t * 5));
      leg = 8 * abs(S(t * 5));
    }
    // Thinking: a fly keeps looping round while the eye bumps bob in turn.
    if (m === 'thinking') {
      fly = 1;
      bL = 2.2 * S(t * 3);
      bR = 2.2 * S(t * 3 + Math.PI);
    }
    if (m === 'talking') hw = 30 + 3 * max(0, S(t * 10));
    if (m === 'surprised') {
      bL = bR = -4;
      hh = 18;
    }
    if (m === 'paused') {
      hh = 14;
      bL = bR = 3;
      pose.ty = 2;
    }
    const fx = 50 + 30 * S(t * 1.8),
      fy = 24 + 6 * S(t * 3.6);
    const legL = [
      [24, 70],
      [14 - leg * 0.4, 76 + leg * 0.3],
      [19, 84 + leg * 0.5],
      [28, 84],
    ];
    return {
      strokes: [
        { c: 'a', pts: arc(41, 50 + bL, 9.5, -90, 270, 13), n: 20 },
        { c: 'a', pts: arc(59, 50 + bR, 9.5, -90, 270, 13), n: 20 },
        { c: 'a', pts: sq(50, 66, hw, hh, 2.4), n: 30 },
        { c: 'a', pts: legL },
        { c: 'a', pts: legL.map(([x, y]) => [100 - x, y]) },
        {
          c: 'b',
          pts: [
            [fx, fy],
            [fx + 0.01, fy],
          ],
          o: fly,
          detail: true,
        },
      ],
      eyes: { x: 50, y: 50 + (bL + bR) / 2 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2),
};
